var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarehouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warehouse",
    transform: "translate(-136 -137)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_10",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 10",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(136 137)",
    fill: "#3a4557"
  }), /*#__PURE__*/React.createElement("path", {
    id: "solid_warehouse",
    "data-name": "solid warehouse",
    d: "M13.782,9.65H3.73a.219.219,0,0,0-.219.219l0,1.313a.219.219,0,0,0,.219.219H13.782A.219.219,0,0,0,14,11.181V9.868A.219.219,0,0,0,13.782,9.65Zm0,2.625H3.722a.219.219,0,0,0-.219.219l0,1.313a.219.219,0,0,0,.219.219H13.782A.219.219,0,0,0,14,13.806V12.494A.219.219,0,0,0,13.782,12.275Zm0-5.25H3.735a.219.219,0,0,0-.219.219l0,1.313a.219.219,0,0,0,.219.219H13.782A.219.219,0,0,0,14,8.556V7.243A.219.219,0,0,0,13.782,7.025Zm2.912-3.8L9.254.125a1.317,1.317,0,0,0-1.009,0L.807,3.224A1.316,1.316,0,0,0,0,4.435v9.371a.219.219,0,0,0,.219.219H2.406a.219.219,0,0,0,.219-.219V7.025a.885.885,0,0,1,.891-.875H13.984a.885.885,0,0,1,.891.875v6.782a.219.219,0,0,0,.219.219h2.188a.219.219,0,0,0,.219-.219V4.435A1.316,1.316,0,0,0,16.694,3.224Z",
    transform: "translate(139.25 140.975)",
    fill: "#fc1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.db8777e8bb4d1282a6d39d6fb154a7a3.svg";
export { ForwardRef as ReactComponent };